import {DOCUMENT} from '@angular/common';
import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {Router} from '@angular/router';

import {AppRoutes} from 'frontend/constants/routes';

/**
 * An access denied page that displays a message when a user attempts to access
 * a route that their organization is not authorized to view or when no default
 * landing page is available.
 */
@Component({
  selector: 'tap-access-denied',
  templateUrl: './access_denied.ng.html',
  styleUrl: './access_denied.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatIconModule],
})
export class AccessDeniedPage {
  private readonly router = inject(Router);
  private readonly document = inject(DOCUMENT);

  protected goToLogin() {
    this.router.navigate([AppRoutes.LOGIN.path]);
  }

  protected refreshPage() {
    this.document.defaultView?.location.reload();
  }
}
